import Chip from "@mui/material/Chip";
import type { GridValidRowModel } from "@mui/x-data-grid";

import {
  createSelectEditCellRenderer,
  createSelectViewCellRenderer,
  type SelectOption,
} from "./SelectCell";

const CHIP_SIZE_SMALL = "small";

export interface ChipOption extends SelectOption {
  fontColor?: string;
  backgroundColor?: string;
}

function renderChip(option: ChipOption) {
  return (
    <Chip
      label={option.label}
      size={CHIP_SIZE_SMALL}
      sx={{
        bgcolor: option.backgroundColor,
        color: option.fontColor,
      }}
    />
  );
}

export function createChipViewCellRenderer<Row extends GridValidRowModel>(
  optionMap: Map<string, ChipOption>,
) {
  return createSelectViewCellRenderer<Row, ChipOption>(optionMap, renderChip);
}

export function createChipSelectEditCellRenderer<Row extends GridValidRowModel>(
  options: ChipOption[],
) {
  return createSelectEditCellRenderer<Row, ChipOption>(options, renderChip);
}
